<template lang="pug">
    .box
        v-server-table(ref='datatable', :url='api', :name='tableName', :columns='columns', :options='options')
        import-planogram(:type='type')
        delete-planogram(ref='deletePlanogramModal')
</template>

<script>
import { mapActions } from 'vuex';
import { Event } from '../../../event-bus';
import Auth from '@js/plugins/auth';
import ImportPlanogram from './import-planogram.vue';
import DeletePlanogram from './delete-planogram.vue';
const TableName = 'VUETABLE_PLANOGRAM';

export default {
    components: {
        ImportPlanogram,
        DeletePlanogram,
    },

    data() {
        var that = this;
        let canManageItems = Auth.hasAnyPermission(
            'franchise_manage_planogram',
        );

        let actionButtons = [
            {
                title: 'Import',
                action: () => {
                    this.showImportForm();
                    this.type = 0;
                },
            },
            {
                title: 'Replace',
                action: () => {
                    this.showImportForm();
                    this.type = 1;
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        return {
            type: 0,
            tableName: TableName,
            api: Laroute.route('franchise.inventory.planogram.vue_table_list'),
            columns: [
                'name',
                'planogram_product_count',
                'description',
                'last_updated_at',
                'latest_updated_by',
                'effective_at',
                'deletion_effective_at',
            ],
            options: {
                checkbox: canManageItems,
                checkboxActions: [
                    {
                        title: 'Delete Planogram',
                        callback: () => {
                            this.deleteModal();
                        },
                    },
                ],
                sortable: ['name', 'effective_at'],
                texts: {
                    count:
                        'Showing {from} to {to} of {count} records|{count} records|One record',
                    limit: 'Records per page :',
                    filterPlaceholder: 'Search...',
                },
                headings: {
                    name: 'Planogram Name',
                    planogram_product_count: 'Barcode Quantity',
                    description: 'Updated Description',
                    last_updated_at: 'Updated At',
                    latest_updated_by: 'Updated By',
                    effective_at: 'Effective At',
                    deletion_effective_at: 'Deletion Effective At',
                },
                actionButtons: actionButtons,
                importCallback: that.showImportForm,
            },
        };
    },
    computed: {
        localSelectedPlanogram: {
            get() {
                return this.$store.getters[`${TableName}_CHECKBOX/getSelected`];
            },

            set(value) {},
        },
    },

    created() {},
    mounted() {
        Event.$on('import-completed', () => {
            this.refresh();
        });

        Event.$on('import-error', () => {
            this.refresh();
        });
    },

    methods: {
        fetchData() {
            this.$refs.datatable.getData();
        },
        showImportForm() {
            $('#import-planogram').modal('show');
        },
        refresh() {
            this.$refs.datatable.getData();
        },
        async deleteModal() {
            const id = this.$refs.datatable.getCheckboxSelected;

            this.$refs.deletePlanogramModal.$emit('show', id);
            this.toggleLoader({
                name: 'get-planogram-count',
            });
            await this.$store.dispatch('planogram/getCountPlanogramProduct', {
                planogram_id: id,
            });
            this.toggleLoader({
                name: 'get-planogram-count',
                start: false,
            });
        },
        ...mapActions('planogram', ['toggleLoader']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/planogram/planogram_table.vue